import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'

export const QuickbetKeypadWrapperStyled = styled.div({
  margin: `0 -${spacing.sm}`,
  paddingBottom: '0.2rem',
})
